import _ from "lodash";
import { Fragment, useState } from "react";

import Checkbox from "@material-ui/core/Checkbox";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import DeleteIcon from "@material-ui/icons/Delete";
import LinkIcon from "@material-ui/icons/Link";
import { Link } from "react-router-dom";

import AlertDialog from "../../components/AlertDialog";
import Button from "../../components/Button";
import TextField from "../../components/TextField";
import { useNotification } from "../../context/notification";
import { apiRequest } from "../../utils/api";
import { getLocalValue } from "../../utils/auth";
import { utcToLocal } from "../../utils/datetime";

import { Tooltip } from "@material-ui/core";
import FormHelperText from "@material-ui/core/FormHelperText";
import { useTranslation } from "react-i18next";
import { useCampaign } from "../../context/campaign";
import { decimalCheck } from "../../utils/customValidation";
import styles from "./index.module.scss";

const emptySubjectTemplate = {
  subject_id: "",
  subjectable_type: '',
  metrics: "",
  occurrence: 0,
  link: "",
  project_target_kpi: "",
  mtd_metric: "",
};

export default function SubjectListInput({
  list,
  setList,
  disabled,
  coacheeId,
  coachId,
  name,
  onChange,
  subjectMetric,
  onDelete,
  subjectDropdownList,
  hideProjectTargetKpi,
  hideCurrentMetrics,
  subjectError,
  ...props
}) {
  const { addNotification } = useNotification();
  const { t } = useTranslation();
  const { selectedCampaign } = useCampaign();
  const [dialogIsOpen, setDialogIsOpen] = useState(false);
  const [currentActiveIndex, setCurrentActiveIndex] = useState(null);
  const [linkTextFieldValue, setLinkTextFieldValue] = useState("");
  const [occurrenceSubjectList, setOccurrenceSubjectList] = useState([]);
  const [open, setOpen] = useState(false);
  const [openVerbal, setOpenVerbal] = useState(false);
  const [issueWarningIndex, setIssueWarningIndex] = useState(null);
  const [issueWarning, setIssueWarning] = useState([]);
  const [issueVerbalIndex, setIssueVerbalIndex] = useState(null);
  const [issueVerbal, setIssueVerbal] = useState([]);
  const [verbalWarningSubject, setVerbalWarningSubject] = useState(null);
  const [isVerbalWarningIssued, setIsVerbalWarningIssued] = useState(false);

  const handleInsertLink = index => {
    setCurrentActiveIndex(index);
    setLinkTextFieldValue(list[index]["link"]);
    setDialogIsOpen(true);
  };

  const handleDialogClose = () => {
    setCurrentActiveIndex(null);
    setDialogIsOpen(false);
  };

  const handleAdd = () => {
    let isSubjectValid = false;

    list.forEach(subject => {
      if (parseInt(props.sessionTypeId) === 2) {
        if (!hideProjectTargetKpi && !hideCurrentMetrics) {
          if (
            subject.subject_id === "" ||
            subject.metrics === ""
          ) {
            isSubjectValid = false;
          }
        } else {
          isSubjectValid = true
        }
      }
      else {
        if (
          subject.subject_id === "" ||
          subject.metrics === ""
        ) {
          isSubjectValid = false;
        } else {
          isSubjectValid = true;
        }
      }
    });

    if (isSubjectValid || list.length === 0) {
      let newObj = Object.assign({}, emptySubjectTemplate);
      let newList = _.cloneDeep(list);
      newList.push(newObj);
      setList(newList);
    } else {
      addNotification(t("error.pleaseSelectSubjectAndAddMetrics"), "error");
    }
  };

  const handleDelete = deleteIndex => {
    let newList = _.cloneDeep(list);
    newList.splice(deleteIndex, 1);
    let newOccurrenceList = _.cloneDeep(occurrenceSubjectList);
    newOccurrenceList.splice(deleteIndex, 1);
    setList(newList);
    setOccurrenceSubjectList(newOccurrenceList);
    if (newList.length === 0) {
      onDelete();
    }
  };

  // handle change of a particular item's field given its index
  const handleChange = (value, fieldName, index) => {
    let newList = structuredClone(list);

    if (fieldName === "link") {
      const regex = !/^https?:\/\//i.test(value);
      value = regex ? "http://" + value : value;
    }

    if (fieldName === "metrics") {
      value = decimalCheck(value, 2);
    }
    if (fieldName === "project_target_kpi") {
      value = decimalCheck(value, 2);
    }

    newList[index][fieldName] = value;
    setList(newList);
  };

  /**
   * we map the selected subject to the list state
   * 
   * this state later consumed by Formik to populate the corresponding
   * input fields (mtd_metric, project_target_kpi).
   */
  const handleSelectedSubject = (selectedSubject, index) => {
    const newSubjectList = list.map((subject, i) => {
      if (i === index) {
        return {
          ...subject,
          subject_id: selectedSubject.value,
          project_target_kpi: selectedSubject.project_target_kpi
            ? decimalCheck(selectedSubject.project_target_kpi, 2)
            : '',
          mtd_metric: selectedSubject.mtd_metric
            ? decimalCheck(selectedSubject.mtd_metric, 2)
            : '',
          subjectable_type: selectedSubject.subjectable_type,
        }
      }

      return subject;
    });

    setList(newSubjectList);
  }

  const getOccurrenceSubjectList = (subject, index) => {
    //  /getFailedSubjectDetails
    apiRequest
      .get(`/api/getFailedSubjectDetails`, {
        params: {
          coachee_id: coacheeId,
          subject_id: subject.id,
          subjectable_type: subject.subjectable_type,
        },
      })
      .then(resp => {
        let data = resp.data && resp.data.data ? resp.data.data : [];
        let occurrenceList = [...occurrenceSubjectList];
        if (occurrenceList[index]) {
          occurrenceList[index] = data.session;
        } else {
          occurrenceList = [...occurrenceSubjectList, data.session];
          setIssueWarning([...issueWarning, false]);
          setIssueVerbal([...issueVerbal, false]);
        }
        setIsVerbalWarningIssued(data.verbal_warning >= 2 ? true : false);
        setOccurrenceSubjectList(occurrenceList);
      })
      .catch(error => { })
      .finally(() => { });
  };

  const handleIssueWarningChange = (event, index) => {
    if (event.target.checked) {
      setOpen(true);
      setIssueWarningIndex(index);
      let issueWarningArray = [...issueWarning];
      issueWarningArray[index] = true;
      setIssueWarning(issueWarningArray);
    }
  };
  const handleIssueVerbalWarningChange = (event, index, subject) => {
    if (event.target.checked) {
      setOpenVerbal(true);
      setVerbalWarningSubject(subject);
      setIssueVerbalIndex(index);
      let issueVerbalArray = [...issueVerbal];
      issueVerbalArray[index] = true;
      setIssueVerbal(issueVerbalArray);
    }
  };
  const sentVerbalWarning = value => {
    setOpenVerbal(false);
    if (value) {
      const formObj = {
        session_ids: [],
        subject_id: verbalWarningSubject.subject_id.replace(`-${verbalWarningSubject.subjectable_type}`, ''),
        subjectable_type: verbalWarningSubject.subjectable_type,
        uid: getLocalValue("uid"),
        coach_id: coachId,
        coachee_id: coacheeId,
      };

      occurrenceSubjectList[issueVerbalIndex].map(list => {
        formObj.session_ids.push(list.session_id);
      });

      apiRequest
        .post(`/api/issueVerbalWarning`, formObj)
        .then(resp => {
          if (resp.status === 200) {
            addNotification(`verbal warning updated`, "success");
          }
        })
        .catch(error => {
          addNotification(`${error}`, "error");
        })
        .finally(() => { });
    } else {
      let issueVerbalArray = [...issueVerbal];
      issueVerbalArray[issueVerbalIndex] = false;
      setIssueVerbal(issueVerbalArray);
    }
  };

  const sentIssueWarningReport = value => {
    setOpen(false);
    if (value) {
      const formObj = {
        session_ids: [],
        coachee_id: coacheeId,
        created_by: getLocalValue("uid"),
        campaign_id: selectedCampaign,
      };
      occurrenceSubjectList[issueWarningIndex].map(list => {
        formObj.session_ids.push(list.session_id);
      });

      apiRequest
        .post(`/api/sendPIPNotification`, formObj)
        .then(resp => {
          if (resp.status === 200) {
            addNotification(`Warning report sent to HR`, "success");
          }
        })
        .catch(error => {
          addNotification(`${error}`, "error");
        })
        .finally(() => { });
    } else {
      let issueWarningArray = [...issueWarning];
      issueWarningArray[issueWarningIndex] = false;
      setIssueWarning(issueWarningArray);
    }
  };

  const checkIfSelected = value => {
    const isSelected = [...list].filter(sub => {
      return sub.subject_id === value;
    });
    return isSelected.length > 0;
  };

  return (
    <div className={styles.container}>
      <Dialog
        className={styles.dialog}
        open={dialogIsOpen}
        onClose={handleDialogClose}
      >
        <DialogTitle id="form-dialog-title">
          Insert Link to Performance Data
        </DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            id="form-dialog-link"
            label="Link"
            type="url"
            fullWidth
            defaultValue={
              list[currentActiveIndex] ? list[currentActiveIndex]["link"] : ""
            }
            onChange={e => setLinkTextFieldValue(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDialogClose} color="primary">
            Cancel
          </Button>
          <Button
            onClick={() => {
              handleDialogClose();
              handleChange(linkTextFieldValue, "link", currentActiveIndex);
            }}
            color="primary"
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
      <div className={styles.subjectList}>
        {list && list.map((item, index) => {
          return (
            <div key={index} className={styles.listItem}>
              <div className={styles.index}>
                <div>{index + 1}</div>
              </div>
              <div className={styles.fields}>
                <Select
                  disabled={issueWarning[index] || issueVerbal[index]}
                  className={styles.fieldSubject}
                  variant="outlined"
                  value={list[index].subject_id}
                  name={`${name}.${index}.subject_id`}
                  onChange={e => {
                    const selectedSubject = subjectDropdownList.find(subject => {
                      return subject.value === e.target.value;
                    });

                    if (!selectedSubject) {
                      console.warn(`Selected subject with id ${e.target.value} not found`)
                      return;
                    }

                    handleSelectedSubject(selectedSubject, index);
                    getOccurrenceSubjectList(selectedSubject, index);
                    onChange(e);
                  }}
                >
                  {subjectDropdownList &&
                    subjectDropdownList.map((item, i) => {
                      return (
                        <MenuItem
                          key={i}
                          value={item.value}
                          disabled={checkIfSelected(item.value)}
                        >
                          {item.label}
                        </MenuItem>
                      );
                    })}
                </Select>
                {props.showError?.subjects &&
                  subjectError &&
                  subjectError.length > 0 &&
                  subjectError[index]?.subject_id && (
                    <FormHelperText style={{ color: "#c73426" }}>
                      Please add a subject
                    </FormHelperText>
                  )}
                {!hideCurrentMetrics && (
                  <div className={styles.fieldMetricsWrapper}>
                    <div style={{ width: "100%" }}>
                      <span className={styles.fieldLabel}>
                        {t("growForm.current")}
                      </span>
                      <TextField
                        type="number"
                        className={styles.fieldMetrics}
                        variant="outlined"
                        placeholder={t("growForm.enterMetrics")}
                        value={item.metrics}
                        disabled={disabled}
                        onChange={e =>
                          handleChange(e.target.value, "metrics", index)
                        }
                      />
                    </div>
                    <Button
                      className={styles.insertLinkBtn}
                      variant="contained"
                      disabled={disabled}
                      disableRipple
                      disableElevation
                      onClick={() => handleInsertLink(index)}
                    >
                      <LinkIcon className={styles.insertLinkBtnIcon} />
                      <Tooltip
                        title="Insert Link to Performance Data"
                        placement="bottom"
                      >
                        <span className={styles.insertLinkBtnLabel}>
                          Insert link
                        </span>
                      </Tooltip>
                    </Button>
                  </div>
                )}
                {props.showError?.subjects &&
                  subjectError &&
                  subjectError.length > 0 &&
                  subjectError[index]?.result_metrics && (
                    <FormHelperText style={{ color: "#c73426" }}>
                      Please add subject metric
                    </FormHelperText>
                  )}
                {!hideProjectTargetKpi && (
                  <div className={styles.fieldMetricsWrapper}>
                    <div style={{ width: "100%" }}>
                      <span className={styles.fieldLabel}>
                        {t("growForm.projectTargetKpi")}
                      </span>
                      <TextField
                        type="number"
                        className={styles.fieldProjectKpi}
                        variant="outlined"
                        placeholder={t("growForm.enterProjectKpi")}
                        value={item.project_target_kpi}
                        disabled={disabled}
                        onChange={e =>
                          handleChange(
                            e.target.value,
                            "project_target_kpi",
                            index
                          )
                        }
                      />
                    </div>
                  </div>
                )}
                {!hideProjectTargetKpi && (
                  <div className={styles.fieldMetricsWrapper}>
                    <div style={{ width: "100%" }}>
                      <span className={styles.fieldLabel}>
                        {t("growForm.mtd")}
                      </span>
                      <TextField
                        type="number"
                        className={styles.fieldProjectKpi}
                        variant="outlined"
                        placeholder={t("growForm.enterMtdMetrics")}
                        value={item.mtd_metric}
                        disabled={disabled}
                        onChange={e =>
                          handleChange(
                            e.target.value,
                            "mtd_metric",
                            index
                          )
                        }
                      />
                    </div>
                  </div>
                )}
                {props.projectTargetKpiError && (
                  <FormHelperText style={{ color: "#c73426" }}>
                    Please add project target KPI
                  </FormHelperText>
                )}
                {occurrenceSubjectList[index] &&
                  occurrenceSubjectList[index].length > 0 && (
                    <div className={styles.fieldMetricsWrapper}>
                      <div style={{ width: "100%" }}>
                        <ul className={styles.occurrenceSubject}>
                          {occurrenceSubjectList[index].map(subList => (
                            <li key={subList.session_id}>
                              Previous misconduct{" "}
                              <Link
                                to={`/sessions/archive-session/${subList.session_id}`}
                              >
                                {utcToLocal(subList.session_datetime).format(
                                  "DD MMM YYYY"
                                )}{" "}
                                session{" "}
                              </Link>
                            </li>
                          ))}
                        </ul>
                        <div className={styles.warningCheckbox}>
                          <FormControlLabel
                            className={styles.warningCheckboxLabel}
                            value="issueVerbalWarning"
                            disabled={
                              isVerbalWarningIssued || issueVerbal[index]
                            }
                            control={
                              <Checkbox
                                color="primary"
                                checked={issueVerbal[index]}
                                onChange={event => {
                                  handleIssueVerbalWarningChange(
                                    event,
                                    index,
                                    list[index]
                                  );
                                }}
                              />
                            }
                            label="Issue verbal warning"
                            labelPlacement="end"
                          />
                          <FormControlLabel
                            className={styles.warningCheckboxLabel}
                            value="issueWarning"
                            disabled={issueWarning[index]}
                            control={
                              <Checkbox
                                color="primary"
                                checked={issueWarning[index]}
                                onChange={event => {
                                  handleIssueWarningChange(event, index);
                                }}
                              />
                            }
                            label="Process a warning"
                            labelPlacement="end"
                          />
                        </div>
                      </div>
                    </div>
                  )}
              </div>
              {!issueWarning[index] && !issueVerbal[index] && (
                <div className={styles.actions}>
                  <DeleteIcon
                    onClick={() => handleDelete(index)}
                    disabled={issueWarning[index]}
                  />
                </div>
              )}
            </div>
          );
        })}
      </div>
      <AlertDialog
        open={open}
        onClose={sentIssueWarningReport}
        title="Process warning?"
        body="Discussed and consensus achieved with Manager and/or HR?"
        footer={
          <Fragment>
            <Button
              onClick={() => {
                sentIssueWarningReport(false);
              }}
            >
              No
            </Button>
            <Button
              onClick={() => {
                sentIssueWarningReport(true);
              }}
              color="primary"
              variant="contained"
            >
              Yes - Trigger Warning Notification to HR
            </Button>
          </Fragment>
        }
      />
      <AlertDialog
        open={openVerbal}
        onClose={() => {
          sentVerbalWarning(false);
        }}
        title="Are you issuing a verbal warning?"
        body=""
        footer={
          <Fragment>
            <Button
              onClick={() => {
                sentVerbalWarning(false);
              }}
            >
              Cancel
            </Button>
            <Button
              onClick={() => {
                sentVerbalWarning(true);
              }}
              color="primary"
              variant="contained"
            >
              Yes, issue verbal warning
            </Button>
          </Fragment>
        }
      />
      <div className={styles.subjectListBtnWrapper}>
        <Button
          variant="outlined"
          color="secondary"
          size="small"
          fullWidth
          onClick={handleAdd}
          disabled={disabled | (list.length > 4)}
        >
          {t("createSession.addSubjects")}
        </Button>
      </div>
    </div>
  );
}